/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_PhoneInputs */

const es_footer_phone = /** @type {(inputs: Footer_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teléfono · +34 679 855 762`)
};

const gl_footer_phone = /** @type {(inputs: Footer_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teléfono · +34 679 855 762`)
};

const en_footer_phone = /** @type {(inputs: Footer_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone · +34 679 855 762`)
};

/**
* | output |
* | --- |
* | "Phone · +34 679 855 762" |
*
* @param {Footer_PhoneInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_phone = /** @type {((inputs?: Footer_PhoneInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_PhoneInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_phone(inputs)
	if (locale === "en") return en_footer_phone(inputs)
	return es_footer_phone(inputs)
});